import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b71b281"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "alert alert-danger alert-dismissible",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "An Error Has Occurred", -1))

import { useRoot } from '@/stores/root';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  setup(__props) {

    const rootState = useRoot();
    const dismissError = () => rootState.error = false;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-warning",
        "aria-label": "close",
        onClick: dismissError
      }, " Dismiss ")
    ])
  ]))
}
}

})